module.exports = "<div class=\"bws-notification\" ng-show=\"message.length > 0\">\r\n    <h3 ng-show=\"title\" ng-bind-html=\"title\"></h3>\r\n    <div class=\"message\" ng-bind-html=\"message\"></div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/notification/bws-notification-template.html
 ** module id = 968
 ** module chunks = 1
 **/